import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMap,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import './MapStyleControls.css';

interface MapStyleControlsProps {
  mapStyle: string;
  onStyleChange: (style: string) => void;
}

const MapStyleControls: React.FC<MapStyleControlsProps> = ({ mapStyle, onStyleChange }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const mapStyles = [
    {
      id: 'dark',
      label: '🌙 Dark',
      description: 'Dark theme'
    },
    {
      id: 'light', 
      label: '☀️ Light',
      description: 'Light theme'
    },
    {
      id: 'streets',
      label: '🗺️ Streets',
      description: 'Street view'
    },
    {
      id: 'satellite',
      label: '🛰️ Satellite',
      description: 'Satellite view'
    }
  ];

  const getCurrentStyleLabel = () => {
    const currentStyle = mapStyles.find(style => style.id === mapStyle);
    return currentStyle ? currentStyle.label : '🌙 Dark';
  };

  return (
    <div className={`map-style-controls ${isExpanded ? 'expanded' : 'collapsed'}`}>
      <Button 
        variant="dark" 
        className="map-style-toggle-btn"
        onClick={() => setIsExpanded(!isExpanded)}
        title={`Current: ${getCurrentStyleLabel()}`}
      >
        <FontAwesomeIcon icon={faMap} className="me-2" />
        <span className="btn-text">Map Style</span>
        <FontAwesomeIcon 
          icon={faChevronRight} 
          className={`chevron ${isExpanded ? 'rotated' : ''}`} 
        />
      </Button>
      
      {isExpanded && (
        <div className="map-style-menu">
          <div className="map-style-header">
            <h6 className="map-style-title">Map Style</h6>
            <small className="text-muted">Choose your view</small>
          </div>
          
          <div className="map-style-list">
            {mapStyles.map((style) => (
              <button
                key={style.id}
                className={`map-style-option ${mapStyle === style.id ? 'active' : ''}`}
                onClick={() => {
                  onStyleChange(style.id);
                  setIsExpanded(false); // Collapse after selection
                }}
              >
                <span className="style-label">{style.label}</span>
                <small className="style-description">{style.description}</small>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MapStyleControls;